<script setup lang="ts">
  definePageMeta({
    middleware: ['search'],
  });

  const { t } = useI18n();
  const route = useRoute();
  const router = useRouter();
  const jobsSearchStore = useJobsSearchStore();
  const { $config } = useNuxtApp();

  const searchPageTitle = computed(() => {
    const locations = jobsSearchStore.filters.static.locations;
    if (locations.length > 0) {
      return locations.map((loc) => loc.name).join(', ');
    }

    if (jobsSearchStore.searchItem?.title) {
      return jobsSearchStore.searchItem.title;
    }

    return t('SEARCH_PAGE.TITLE');
  });

  // Generate canonical URL with position names (SEO-friendly)
  const canonicalUrl = computed(() => {
    const baseUrl = $config.public.baseUrl || process.env.NUXT_PUBLIC_BASE_URL || 'https://mojposao.hr';
    const canonicalQuery = getSearchQueryObject({
      static: jobsSearchStore.filters.static,
      dynamic: jobsSearchStore.filters.dynamic
    });
    const queryString = objectToQueryString(canonicalQuery);
    return `${baseUrl}${route.path}${queryString ? `?${queryString}` : ''}`;
  });

  // Search page: regular page with page name first for better SEO
  watch([
    () => jobsSearchStore.filters.static.locations,
    () => jobsSearchStore.searchItem,
    searchPageTitle
  ], () => {
    const title = searchPageTitle.value || t('SEARCH_PAGE.TITLE') || 'Rezultati pretrage';
    usePageHead({
      pageName: title,
      description: t('SEARCH_PAGE.DESCRIPTION'),
    });

    // Also set canonical URL
    useHead({
      link: [{ rel: 'canonical', href: canonicalUrl.value }],
    });

    useSeoMeta({
      ogUrl: canonicalUrl.value,
    });
  }, { immediate: true, deep: true });

  onBeforeRouteLeave(() => jobsSearchStore.cleanFilters());
</script>

<template>
  <div>
    <JobSearchBar show-filters />
    <JobSearchTitle />
    <JobSearchSave />
    <JobSearchResults />
  </div>
</template>
